export const CUSTOMER_AUTHORIZATION_QUERY_KEY = 'customerAuthorizations'
export const EMAIL_ACCOUNTS_QUERY_KEY = 'customerEmailAccounts'
export const SCOPE_FIELD = 'scope'
export const ACTIVE_FIELD = 'isActive'
